export interface Faq {
  q: string
  a: string[]
  list?: string[]
  afterList?: string
}

export const faqs: Faq[] = [
  {
    q: 'How do I receive Workplace Safety Atlas after purchasing?',
    a: ['You receive digital access to the purchased materials after your payment is successfully completed.'],
  },
  {
    q: 'Do I need to be an experienced workplace safety instructor?',
    a: [
      'No. The materials support different levels of professional teaching experience, from instructors building their training libraries to experienced educators looking for additional visual resources.',
    ],
  },
  {
    q: 'Is this system suitable for industrial training centers?',
    a: [
      "Yes. It is designed for workplace safety instructors, industrial trainers, vocational educators and training departments. Materials should be adapted to the organization's actual activities and applicable requirements.",
    ],
  },
  {
    q: 'Is it really a 100% visual system?',
    a: [
      'The six main volumes are designed around technical illustrations, diagrams, comparisons, workplace scenarios and visual learning activities. The five bonuses provide additional written and practical teaching resources.',
    ],
  },
  {
    q: 'Does it include ready-to-use training materials?',
    a: [
      'Yes. The system includes visual references, classroom activities, hazard-recognition challenges and teaching resources that can be incorporated into professional training sessions.',
    ],
  },
  {
    q: 'Does it cover beginner and advanced subjects?',
    a: [
      'Yes. The system includes foundational awareness topics and more detailed industrial hazard-recognition and risk-analysis concepts.',
    ],
  },
  {
    q: 'Can workplace supervisors use this system?',
    a: [
      'Yes. Supervisors involved in suitable workplace safety awareness training may find the reference material helpful, subject to their responsibilities and company training arrangements.',
    ],
  },
  {
    q: 'Does it include all six volumes?',
    a: ['Yes. The complete package includes all six specialized workplace safety atlases.'],
  },
  {
    q: 'Are the five bonuses included?',
    a: ['Yes. The five listed bonuses are included with the complete package at no additional cost under this offer.'],
  },
  {
    q: 'Does it include videos?',
    a: ['No. This is a digital educational resource package containing PDF materials. Videos are not included.'],
  },
  {
    q: 'Is the material in English?',
    a: ['Yes. The materials are written in English for an international audience.'],
  },
  {
    q: 'Can I edit the files?',
    a: ['The materials are provided as PDFs, not editable source files.'],
  },
  {
    q: 'Does this replace official safety training or legal compliance requirements?',
    a: [
      'No. These are educational awareness and instructor-support resources. Applicable regulations, workplace procedures, qualified assessments and equipment-specific practical training remain necessary.',
    ],
  },
  {
    q: 'Is this a one-time purchase?',
    a: ['Yes. The listed package is offered as a one-time payment.'],
  },
]
